import { Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute, Router } from '@angular/router'
import { AuthService } from '@core/auth.service'
import { CodeService } from '@core/code.service'
import { ConfigService } from '@core/config.service'
import { NotifyService } from '@core/notify.service'
import { StageService } from '@core/stage.service'
import { StoreService } from '@core/store.service'
import { TimeService } from '@core/time.service'
import { UserService } from '@core/user.service'
import { CoreBasicService } from './core-basic.service'

@Injectable()
export class CoreService extends CoreBasicService {
   console: boolean = false
   logPrefix: string = '@core - ' + this.constructor.name

   public modeDevel: boolean = false

   public appData: any

   public dialogRef: any

   constructor(
      public code: CodeService,
      public store: StoreService,
      public user: UserService,
      public auth: AuthService,
      public config: ConfigService,
      public stage: StageService,
      public notify: NotifyService,
      public time: TimeService,
      public dialog: MatDialog,
      private router: Router,
      public route: ActivatedRoute
   ) {
      super()

      if (!this.isProduction()) {
         this.enableModeDevel()
      }
   }

   isProduction() {
      return this.config.environment == 'prod'
   }

   enableModeDevel() {
      this.modeDevel = true
      this.console = true
      this.auth.coreBasicService.console = true
      this.stage.console = true
   }

   disableModeDevel() {
      this.modeDevel = false
      this.console = false
      this.auth.coreBasicService.console = false
      this.stage.console = false
   }

   spinnerShow() {
      this.stage.spinnerShow()
   }

   spinnerHide() {
      this.stage.spinnerHide()
   }

   goToRoute(route: string, queryParams?: any, routeParams?: any) {
      if (this.console) console.log(this.logPrefix, 'goToRoute:', route)

      if (!route) route = ''
      if (!queryParams) queryParams = {}
      if (!routeParams) routeParams = {}

      this.router.routeReuseStrategy.shouldReuseRoute = function () {
         return false
      }

      this.router.onSameUrlNavigation = 'reload'

      this.router.navigate([route, queryParams], routeParams) // redirect
   }

   goToSearchProjects() {
      window.location.replace(this.config.pmpHomeUrl)
   }
}

